import React from 'react';
import classNames from 'classnames';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {imageIcLens24px} from '@ey/motif-react-wrapper/assets/icons/index';
import {OutputText} from '@ey/canvascoreservices';

import StyledStatusDot from './StyledStatusDot';

const StatusDot = ({linkRequestId, title}) => {
	const iconProps = {src: imageIcLens24px};
	const props = {
		className: classNames('s-dot', {[`sd-${linkRequestId}`]: linkRequestId})
	};

	return (
		<StyledStatusDot {...props}>
			<MotifIcon {...iconProps} />
			<OutputText body2 light>
				{title}
			</OutputText>
		</StyledStatusDot>
	);
};

export default StatusDot;
